export * from "./buy-cloud-site-setup-page.template";
export { BuyCloudSiteSetupPageTemplate as default } from "./buy-cloud-site-setup-page.template";
